import Modal from './Modal'
import { toast } from 'sonner'
import { Loader } from 'lucide-react'
import { useRef, useState } from 'react'
import { RootState } from '@/store/store'
import { useNavigate } from 'react-router-dom'
import { endpoints } from '@/services/api/endpoints'
import { axios } from '@/services/api/axiosInstance'
import { resetChat } from '@/store/features/chatSlice'
import { useDispatch, useSelector } from 'react-redux'
import { toggleGameDelete } from '@/store/features/systemSlice'

const DeleteGameModal = ({ callBack }: { callBack?: () => void }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const { deleteModal } = useSelector((state: RootState) => state.system)

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const onClose = () => {
    dispatch(toggleGameDelete({ id: '', show: false }))
  }

  const handleConfirmDelete = async () => {
    setLoading(true)
    try {
      await axios.put(
        endpoints.deleteGame.url,
        { game_id: deleteModal.id, restore: false },
        { headers: { 'Content-Type': 'application/json' } }
      )
      dispatch(resetChat())
      navigate('/dashboard/my-games')
      if (callBack) callBack()
    } catch (err) {
      console.error('Error deleting game:', err)
      toast.error('Failed to delete game. Please try again.')
    } finally {
      onClose()
      setLoading(false)
    }
  }

  return (
    <Modal>
      <div
        ref={containerRef}
        onClick={handleBackdropClick}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-md"
      >
        <div className="flex h-fit max-h-[calc(100%-16px)] w-[calc(100%-16px)] flex-col overflow-hidden rounded-lg bg-background text-white lg:w-1/3">
          {!loading && (
            <header className="flex items-center justify-between bg-foreground px-6 py-4">
              <h2 className="text-xl font-semibold">Delete Game</h2>
              <button
                className="text-3xl focus-visible:outline-none"
                onClick={onClose}
              >
                &times;
              </button>
            </header>
          )}
          <div className="p-4">
            {loading ? (
              <p className="flex items-center justify-center text-white">
                <Loader />
              </p>
            ) : (
              <>
                <p className="my-4 text-white">
                  Are you sure you want to permanently delete this game?
                </p>
                <div className="flex justify-end gap-4 pt-4 text-white">
                  <button
                    onClick={onClose}
                    className="rounded-lg border border-orange-500 px-4 py-1"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleConfirmDelete}
                    className="rounded-lg border border-orange-500 bg-orange-500 px-4 py-1"
                  >
                    Delete
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteGameModal
